import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleChangeValue, handlePatch, handleDateChangeEvent, handleDelete, handleDeleteWithoutClose, handlePatchWithoutClose } from '../../../../utils/AxiosUtil';
import axios from 'axios';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import { ClearAllButton } from '../../../common/table/ClearAllButton';
import * as enums from '../../../../utils/EnumMapping';

class CarInsuranceHistory extends Component {

    state = {
        carInsuranceHistories: [],
        licenseNumber: this.props.row.licenseNumber,
        selectedRow: null,
        toDelete: null,

        errors: new Map(),
    }

    componentDidMount() {
        this.callApi()
            .then(res => this.enrich(res.data))
            .catch(err => console.log(err));
    }

    refresh() {
        this.callApi()
            .then(res => this.enrich(res.data))
            .catch(err => console.log(err));
    }

    callApi = async () => {
        const response = await axios.get(`/api/carinsurance/${this.props.row.privateId}`);
        if (response.status !== 200) throw Error(response.message);
        return response;
    };

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "CAR_INSURANCE_HISTORY";

            return item;
        })
        this.setState({ carInsuranceHistories: data })
    }

    handleSubmit = async (event) => {
        // event.persist()
        event.preventDefault();
        const path = '/api/carinsurance';
        if (this.state.toDelete) {
            const requestObject = {
                "privateId": this.state.toDelete.privateId,
            };
            await handleDeleteWithoutClose(path, requestObject, this);
        } else {
            const requestObject = {
                "privateId": this.state.selectedRow.privateId,
                "carId": this.props.row.privateId,
                "billId": this.state.selectedRow.billId,
                "insuranceType": this.state.selectedRow.insuranceType,
                "startDate": this.state.selectedRow.startDate,
                "endDate": this.state.selectedRow.endDate,
                "description": this.state.selectedRow.description,
            };
            await handlePatchWithoutClose(path, requestObject, this);
        }
        this.setState({ toDelete: null, selectedRow: null });
    };

    handleRowClick = (row, e) => {
        if (e.target.closest('.delete-button')) {
            this.handleDeleteClick(row, e);
            return;
        }
        if (this.state.selectedRow?.privateId !== row.privateId) {
            this.setState({ toDelete: null });
        }
        this.setState({ selectedRow: row }); // Use `date` or a unique identifier for selection
    };

    handleTableClick = (e) => {
        // Check if the click is NOT on a row
        if (!e.target.closest("tr")) {
            this.setState({ selectedRow: null });
            this.setState({ toDelete: null });
        }
    };

    handleDescriptionChange = (row, event) => {
        const { value } = event.target;
        const updatedRow = { ...this.state.selectedRow, description: value };
        this.setState({ selectedRow: updatedRow });
    };

    handleDeleteClick = (row, e) => {
        if (this.state.toDelete?.privateId === row.privateId) {
            this.setState({ toDelete: null });
        } else {
            this.setState({ toDelete: row });
        }
        e.stopPropagation();
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit} onClick={this.handleTableClick}>
                <table className="carinsurancehistory-table">
                    <thead>
                        <tr>
                            <th className="start-date">Kezdő Dátum</th>
                            <th className="end-date">Vége Dátum</th>
                            <th className="bill">Számla</th>
                            <th className="insurance-type">Típus</th>
                            <th className="description">Leírás</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.carInsuranceHistories?.map((row) => (
                            <tr
                                key={row.privateId}
                                className={`carinsurancehistory-row ${this.state.selectedRow?.privateId === row.privateId ? "selected" : ""}  ${this.state.toDelete?.privateId === row.privateId ? "to-delete" : ""}`}
                                onClick={(e) => this.handleRowClick(row, e)}
                            >
                                <td className="start-date">{row.startDate}</td>
                                <td className="end-date">{row.endDate}</td>
                                <td className="bill">{row.billLabel}</td>
                                <td className="insurance-type">{enums.getLabel(enums.insuranceTypes, row.insuranceType)}</td>
                                <td className="description">
                                    {this.state.selectedRow?.privateId === row.privateId ? (
                                        <>
                                            <input
                                                value={this.state.selectedRow.description}
                                                onChange={(e) => this.handleDescriptionChange(row, e)}
                                                className="description-input"
                                            />
                                            <div className="delete-button"><ClearAllButton title="Biztosítás törlése" onClick={(e) => this.handleDeleteClick(row, e)} /></div>

                                        </>
                                    ) : (
                                        row.description
                                    )}
                                </td>
                            </tr>))
                        }
                    </tbody>
                </table>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        {this.state.toDelete ? "Töröl" : "Módosít"}
                    </Button>
                </div>
            </form>

        )
    }
}

export default withSnackbar(CarInsuranceHistory);
